export enum ClientEvent {
  OnboardingGoFormzIntent = 'OnboardingGoFormzIntent',
  OnboardingWhosFillingForms = 'OnboardingWhosFillingForms',
  OnboardingWhatToolsYouUse = 'OnboardingWhatToolsYouUse'
}

export enum ClientEventData {
  OnboardingGoFormzIntent_Business = 'business',
  OnboardingGoFormzIntent_Personal = 'personal',
  OnboardingWhosFillingForms_Myself = 'myself',
  OnboardingWhosFillingForms_Team = 'team',
  OnboardingWhosFillingForms_Customers = 'customers',
  OnboardingGoFormzApps_Google = 'google',
  OnboardingGoFormzApps_OneDrive = 'onedrive',
  OnboardingGoFormzApps_Box = 'box',
  OnboardingGoFormzApps_Dropbox = 'dropbox',
  OnboardingGoFormzApps_Procore = 'procore',
  OnboardingGoFormzApps_Smartsheet = 'smartsheet',
  OnboardingGoFormzApps_Salesforce = 'salesforce',
  OnboardingGoFormzApps_SqlServer = 'sqlserver',
  OnboardingGoFormzApps_Egnyte = 'egnyte',
  OnboardingGoFormzApps_Acumatica = 'acumatica'
}
